import React from 'react';
import { useRef } from 'react';
import { useState } from 'react';
import { useLayoutEffect } from 'react';
import { View } from 'react-native';
import { StyleSheet } from 'react-native';
import { Button, Divider, Icon, Input, Text } from 'react-native-elements';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Colors, maxWidth, SPACING } from '../assets/colors';
import { auth, db } from '../firebase';
import firebase from 'firebase';

function RegisterUser({ navigation }) {
    useLayoutEffect(() => {
        navigation.setOptions({
            title: 'Registrieren',
            headerShown: false,
        });
    }, []);

    const [userEmail, setUserEmail] = useState('');
    const [userPassword, setUserPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [emailError, setEmailError] = useState('');
    const [passwordError, setPasswordError] = useState('');

    const emailFieldRef = useRef();
    const passwordFieldRef = useRef();

    function validateEmail() {
        var re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(userEmail);
    }

    function customInAppUID() {
        var result = '';
        var characters = 'abcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for (var i = 0; i < 6; i++) {
            result += characters.charAt(
                Math.floor(Math.random() * charactersLength)
            );
        }
        return result;
    }

    async function registerUser() {
        setEmailError('');
        setPasswordError('');

        var emailCorrect = false;
        var passwordCorrect = false;

        if (userEmail.trim() !== '') {
            if (validateEmail()) {
                emailCorrect = true;
            } else {
                setEmailError('Dies ist keine gültige E-Mail Adresse!');
            }
        } else {
            setUserEmail('');
            setEmailError('Dieses Feld darf nicht leer sein!');
        }

        if (userPassword.trim() !== '') {
            if (userPassword.length > 5 && userPassword.length < 256) {
                passwordCorrect = true;
            } else {
                setPasswordError(
                    'Das Passwort muss mindestens 6 Zeichen und maximal 256 Zeichen lang sein!'
                );
            }
        } else {
            setUserPassword('');
            setPasswordError('Dieses Feld darf nicht leer sein!');
        }

        let inAPPUID = customInAppUID();

        var res = await db
            .collection('userDB')
            .where('inAppUID', '==', inAPPUID)
            .get();

        while (!res.empty) {
            inAPPUID = customInAppUID();
            res = await db
                .collection('userDB')
                .where('inAppUID', '==', inAPPUID)
                .get();
        }

        if (emailCorrect && passwordCorrect) {
            auth.createUserWithEmailAndPassword(userEmail, userPassword).then(
                (res) => {
                    res.user
                        .sendEmailVerification()
                        .then(() => alert('Bitte verifiziere deine E-Mail!'));
                    db.collection('userDB')
                        .doc(res.user.uid)
                        .set({
                            email: userEmail,
                            inAppUID: inAPPUID,
                            registerTime:
                                firebase.firestore.FieldValue.serverTimestamp(),
                        })
                        .then(() =>
                            navigation.reset({
                                index: 0,
                                routes: [{ name: 'homeIndex' }],
                            })
                        );
                }
            );
        }
    }

    return (
        <SafeAreaView
            style={{
                flex: 1,
                backgroundColor: Colors.backgroundDark,
                justifyContent: 'center',
                alignItems: 'center',
            }}
            edges={['left', 'right']}
        >
            <Text style={styles.title}>Registerieren</Text>
            <Input
                containerStyle={styles.containerInput}
                inputContainerStyle={styles.inputContainer}
                leftIcon={{
                    name: 'email',
                    color: Colors.backgroundDark,
                    size: SPACING.MARGIN,
                }}
                placeholder="ihre@email.de"
                value={userEmail}
                onChangeText={(event) => {
                    setUserEmail(event);
                    setEmailError('');
                }}
                autoCapitalize="none"
                ref={emailFieldRef}
                //onSubmitEditing={passwordFieldRef.current.focus()}
                autoFocus
                errorStyle={{ paddingLeft: SPACING.MARGIN }}
                errorMessage={emailError}
            />
            <Input
                containerStyle={styles.containerInput}
                inputContainerStyle={styles.inputContainer}
                leftIcon={{
                    name: 'lock',
                    color: Colors.backgroundDark,
                    size: SPACING.MARGIN,
                }}
                rightIcon={
                    showPassword ? (
                        <Icon
                            name="visibility-off"
                            color={Colors.backgroundDark}
                            onPress={() => setShowPassword(false)}
                        />
                    ) : (
                        <Icon
                            name="visibility"
                            color={Colors.backgroundDark}
                            onPress={() => setShowPassword(true)}
                        />
                    )
                }
                placeholder="Passwort"
                value={userPassword}
                onChangeText={(event) => {
                    setUserPassword(event);
                    setPasswordError('');
                }}
                autoCapitalize="none"
                ref={passwordFieldRef}
                secureTextEntry={!showPassword}
                errorStyle={{ paddingLeft: SPACING.MARGIN }}
                errorMessage={passwordError}
                onSubmitEditing={registerUser}
            />
            <View
                style={{
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    width: '80%',
                    maxWidth: maxWidth,
                }}
            >
                <Button
                    icon={{ name: 'arrow-back', color: 'lightgrey' }}
                    titleStyle={{ color: 'lightgrey' }}
                    type="clear"
                    onPress={() => navigation.goBack()}
                    title="Zurück"
                />
                <Button title="Anmelden" onPress={registerUser} />
            </View>
        </SafeAreaView>
    );
}

const styles = StyleSheet.create({
    title: {
        width: '80%',
        maxWidth: maxWidth,
        fontWeight: '900',
        color: Colors.background,
        fontSize: SPACING.MARGIN * 1.5,
        marginBottom: SPACING.MARGIN * 1.5,
    },
    containerInput: {
        width: '80%',
        maxWidth: maxWidth,
        paddingRight: 0,
        paddingLeft: 0,
    },
    inputContainer: {
        backgroundColor: Colors.background,
        borderBottomWidth: 0,
        paddingHorizontal: SPACING.MARGIN,
        paddingVertical: SPACING.MARGIN / 2,
        borderRadius: SPACING.MARGIN,
    },
});

export default RegisterUser;
